// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'stakeholders';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M12.024 7.848a4.443 4.443 0 0 0-6.048 0M9 5.616a2.52 2.52 0 1 0 0-5.04 2.52 2.52 0 0 0 0 5.04zm4.896 9a2.52 2.52 0 1 0 0-5.04 2.52 2.52 0 0 0 0 5.04zm3.528 2.808c-1.512-1.944-4.392-2.304-6.336-.792a4.126 4.126 0 0 0-.792.792m-6.192-2.808a2.52 2.52 0 1 0 0-5.04 2.52 2.52 0 0 0 0 5.04zm3.6 2.808c-1.512-1.944-4.392-2.304-6.336-.792a4.126 4.126 0 0 0-.792.792'
  />
);

export const viewBox = '0 0 18 18';
